/*global FormController, WebView, moment*/
var dashboardPrefPopupController = new FormController("iz_dashboard_settings", 
    {
        directory: "views/dashboard",
        name: "dashboardPrefPopup",
        route: "dashboard-pref-popup",
        buttonsHTML: "<!-- no button -->",
        openInPopup: true,
        noTitle: true,
        popup: {
            //size can by small, medium, large and wide
            size: "medium"
        }
    }
);

//handle the opening parameters
dashboardPrefPopupController.prepareDataOnEnter = function(data, callback){
    this.api.db.multiread({
        iz_dashboard_settings: { search: {} },
        iz_dashboard_global_settings: { search: {} },
        iz_custom_screen: 
            { search: { 
                type: "dashboard",
                active: true
            } }
    }, function(err, reads){
        if(err){ return callback(err) ;}
        var allSettings = reads.iz_dashboard_settings ;
        var userSettings = {} ;
        var defaultSettings = {} ;
        allSettings.forEach(function(s){
            if(s.user_id){
                userSettings[s.code] = s ;
            }else{
                defaultSettings[s.code] = s ;
            }
        }) ;
        Object.keys(defaultSettings).forEach(function(code){
            if(!userSettings[code]){
                userSettings[code] = defaultSettings[code] ;
            }
        }) ;

        var dashboards = [] ;
        window.APP_MODULES.forEach(function(module){
            if(module.dashboards){
                const moduleDashboards = module.dashboards
                    .sort(function(d1, d2){
                        var d1Position = (d1.position||0);
                        var d2Position = (d2.position||0);
                        return d1Position - d2Position;
                    })
                    .map(function(d){//set default size
                        let baseSize = d.size || "small";
                        return {
                            ...d,
                            size: baseSize,
                            defaultSize: baseSize  
                        };
                    });

                dashboards = dashboards.concat(moduleDashboards);
            }
        }) ;
    

        dashboards = dashboards.filter(function(d){
            return !d.rights || this.api.currentUser.rights[d.rights] ;
        }.bind(this)) ;

        reads.iz_custom_screen.forEach(function(c){
            dashboards.push({
                label: c.name,
                name: c.code+"_"+c.id
            })  ;
        }) ;

        var settings = [] ;
        dashboards.forEach(function(dash, i){
            var dashSettings = {
                label: dash.label,
                code: dash.name,
                size: "default",
                forbiddenSizes: dash.forbiddenSizes,
                defaultSize: WebView.tr("fields.values.iz_dashboard_settings.size."+(dash.defaultSize||"small")),
                sequence: 9999+i,
                user_id: this.api.currentUser.id
            } ;
            if(userSettings[dash.name]){
                dashSettings.size = userSettings[dash.name].size ;
                dashSettings.sequence = userSettings[dash.name].sequence ;
                if(userSettings[dash.name].user_id){
                    dashSettings.id = userSettings[dash.name].id ;
                }
            }
            settings.push(dashSettings) ;
        }.bind(this)) ;

        settings = settings.sort(function(s1, s2){
            return (s1.sequence||0) - (s2.sequence||0) ;
        }) ;

        var globalSettings = null;
        
        reads.iz_dashboard_global_settings.forEach(function(s){
            if(s.user_id){
                globalSettings = s ;
            }else if(!globalSettings){
                delete s.id;
                globalSettings = s ;
            }
        }) ;

        if(!globalSettings){
            globalSettings = { last_n_month : 12 } ;
        }

        var record = { globalSettings: globalSettings, settings: settings } ;
        callback(null, record) ;
    }.bind(this)) ;
} ;

//the popup will never be in read mode, switch to create or modify
dashboardPrefPopupController.onChangeMode = function(ev){
    if(ev.data === "read"){
        if(!this.data.id){
            this.setMode("create") ;
        }else{
            this.setMode("modify") ;
        }
    }
} ;

dashboardPrefPopupController.onClose = function(){
    this.mode = 'read' ; //avoid abort input warning
};

//close when user click on cancel button
dashboardPrefPopupController.onCancel = function(){
    this.view.close() ;
};

dashboardPrefPopupController.getRecordsToSave = function (viewData, dataBeforeModif, callback) {
    var records = [] ;
    viewData.settings.forEach(function(s, i){
        s.sequence = i ;
        records.push({
            table: "iz_dashboard_settings",
            record: s
        }) ;
    }) ;

    viewData.globalSettings.user_id = this.api.currentUser.id ;
    
    records.push({
        table: "iz_dashboard_global_settings",
        record: viewData.globalSettings
    }) ;

    if(viewData.allUsers){
        records.push({
            table: "iz_dashboard_settings",
            action: "removeWhere",
            record: {
                user_id: null
            }
        });
        records.push({
            table: "iz_dashboard_global_settings",
            action: "removeWhere",
            record: {
                user_id: null
            }
        });

        viewData.settings.forEach(function(s, i){
            s = JSON.parse(JSON.stringify(s)) ;
            delete s.id;
            delete s.user_id;
            s.sequence = i ;
            records.push({
                table: "iz_dashboard_settings",
                record: s
            }) ;
        }) ;
        var globalSettings = JSON.parse(JSON.stringify(viewData.globalSettings)) ;
        delete globalSettings.id;
        delete globalSettings.user_id;
        records.push({
            table: "iz_dashboard_global_settings",
            record: globalSettings
        }) ;
    }

    return callback(null, records) ;
} ;

//save and close on validate
dashboardPrefPopupController.onValidate = function(){
    this.view.longTask(function(done){
        this.doValidate(function(err, savedRecord){
            if(err){ return done(err); }
            if(!savedRecord){
                //check failed
                return done() ;
            }
            this.mode = 'read' ; //avoid abort input warning
            this.view.close() ;
            done() ;
        }.bind(this)) ;
    }.bind(this)) ;
};

dashboardPrefPopupController.onReset = function(){
    this.view.longTask(function(done){
        this.api.db.iz_dashboard_settings.search({user_id: this.api.currentUser.id}, function(err, userSettings){
            if(err){ return done(err); }
            var records = [] ;
            userSettings.forEach(function(s){
                records.push({
                    table: "iz_dashboard_settings",
                    action: "remove",
                    record : { id: s.id }
                }) ;
            }) ;
            this.api.db.transactionalChanges(records, function(err){
                if(err){ return done(err); }
                this.mode = 'read' ; //avoid abort input warning
                this.view.close() ;
                done() ;
            }.bind(this)) ;
        }.bind(this)) ;
    }.bind(this)) ;
} ;

module.exports = dashboardPrefPopupController ;